import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import { IS_COUNTRY } from '../../constants/countries'
import { useBoundStore } from '../../store/store'
import { openChat } from '../../utils/liveChat'
import LoginModal from '../common/log-in-modal'
import BouncingGift from '../icon/bouncing-gift'
import CashierDrawerTabs from './cashier-drawer-tabs'
import CasinoDrawerTabs from './casino-drawer-tabs'
import MyProfileDrawerTabs from './my-profile-drawer-tabs'
import SportsDrawerTabs from './sports-drawer-tabs'

type TabsProps = {
  closeProfileDrawer: () => void
  showProfileDrawer: () => void
}
type TabItem = {
  label: string
  link: string
  isProtected: boolean
  badge?: JSX.Element
  onClick?: () => void
}

const Tabs = ({ closeProfileDrawer }: TabsProps) => {
  const is_agent = useBoundStore(state => state.user.is_agent)
  const verif_request_count = useBoundStore(
    state => state.user.verif_request_count,
  )
  const username = useBoundStore(state => state.user.username)
  const logInModal = useModal(LoginModal)
  const { t } = useTranslation(['common', 'drawer', 'kyc', 'blogs'])

  const casinoTabLink = IS_COUNTRY.MX ? '/casino' : '/casino/popular'

  const TABS: TabItem[] = [
    {
      label: 'APUESTAS DEPORTIVAS',
      link: IS_COUNTRY.MX ? '/sports' : '/sports/bti',
      isProtected: false,
    },
    {
      label: t('drawer:casino'),
      link: `/casino/popular`,
      isProtected: false,
    },
    {
      label: t('promotions', { ns: 'drawer' }),
      link: '/promotions',
      isProtected: false,
    },
    {
      label: t('blogs', { ns: 'blogs' }),
      link: '/blogs',
      isProtected: false,
    },
    {
      label: t('drawer:my-profile'),
      link: '/profile',
      isProtected: true,
    },
    {
      label: t('drawer:cashier'),
      link: '/cashier',
      isProtected: true,
    },
    {
      label: t('referral', { ns: 'drawer' }),
      link: '/profile/referral',
      isProtected: true,
    },
    {
      label: t('drawer:app-feedback'),
      link: '/profile/feedback',
      badge: <BouncingGift />,
      isProtected: true,
    },
    ...(is_agent === '0'
      ? []
      : [
          {
            label: t('affiliate', { ns: 'drawer' }),
            link: '/profile/affiliate',
            isProtected: true,
          },
          {
            label: t('commission', { ns: 'drawer' }),
            link: '/profile/commission',
            isProtected: true,
          },
        ]),
    {
      label: t('free-bonus', { ns: 'drawer' }),
      link: '/profile/free-bonus',
      isProtected: true,
    },
    {
      label: 'Chat en línea',
      link: '',
      isProtected: false,
      onClick: openChat,
    },
  ]

  return (
    <>
      {TABS.map(item =>
        item.link === casinoTabLink ? (
          <CasinoDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : item.link === '/cashier' ? (
          <CashierDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : item.link === '/profile' ? (
          <MyProfileDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
            verif_request_count={verif_request_count}
          />
        ) : IS_COUNTRY.MX && item.link === '/sports' ? (
          <SportsDrawerTabs
            key={item.link}
            closeProfileDrawer={closeProfileDrawer}
          />
        ) : (
          <Link
            key={item.link}
            to={item.isProtected && !username ? undefined : item.link}
            className="text-highlight uppercase text-base w-full inline-flex items-center gap-1 pl-[30px] pr-[15px] py-2.5 border-b-[#f5f6f9] dark:border-b-[#1f223c] border-b border-solid"
            onClick={() => {
              closeProfileDrawer()
              if (item.isProtected && !username) {
                logInModal.show()
                return
              }
              item.onClick?.()
            }}
            search={{}}
            params={{}}>
            {item.label} {item?.badge}
          </Link>
        ),
      )}
    </>
  )
}

export default Tabs
